import extractExtraErrorProps from '../util/extractExtraErrorFields';
import './types';
import type {ExtraData, Severity} from '../types';
import {getBundleMetadata} from '../util/getBundleMetadata';
import {Reporter, ReportOpts} from '../Reporter';

export const EXTRA_DATA_SECTION = 'moreInfo';
export const ORIGINAL_ERROR_SECTION = 'originalError';
export const BUNDLE_ERROR_SECTION = 'bundleErrors';

const notifyToBugsnag = (message: string, error: Error, severity: Severity, extraData?: ExtraData) => {
    const errorExtraData = extractExtraErrorProps(error);

    window.Bugsnag.notify(error, async event => {
        try {
            const appBundle = event.errors[0].stacktrace.find(t => t.file.endsWith('app-bundle.js'));
            if (appBundle) {
                const releaseMetadata = await getBundleMetadata(appBundle.file);

                if (releaseMetadata) {
                    event.apiKey = releaseMetadata.appKey;
                    event.app.version = releaseMetadata.version;
                }
            }
        } catch (error) {
            event.addMetadata(BUNDLE_ERROR_SECTION, {error});
        }

        event.severity = severity;
        const originalError = event.errors[0].errorMessage;
        event.errors[0].errorMessage = message;

        if (originalError !== message) {
            event.addMetadata(ORIGINAL_ERROR_SECTION, 'message', originalError);
        }

        if (errorExtraData) {
            event.addMetadata(ORIGINAL_ERROR_SECTION, errorExtraData);
        }

        if (extraData) event.addMetadata(EXTRA_DATA_SECTION, extraData);
    });
};

export class BugsnagReporter implements Reporter {
    public report({severity, message, error, extra}: ReportOpts) {
        if (window.Bugsnag) {
            notifyToBugsnag(message, error ?? new Error(message), severity, extra);
        } else {
            console.warn('Could not report, bugsnag unavailable', {severity, message, error, extra});
        }
    }
}
